// eslint-disable-next-line import/prefer-default-export
export const validateInnAndKpp = (inn: string, kpp: string) =>
  (inn.trim().length === 10 || inn.trim().length === 12) &&
  !Number.isNaN(+inn.trim()) &&
  (kpp.trim().length === 0 || kpp.trim().length === 9) &&
  !Number.isNaN(+kpp.trim());

export const validateInn = (inn: string) =>
  (inn.trim().length === 10 || inn.trim().length === 12) && !Number.isNaN(+inn.trim());

export const validateKpp = (kpp: string) =>
  (kpp.trim().length === 0 || kpp.trim().length === 9) && !Number.isNaN(+kpp.trim());

export const suppliersValidation = (code: string) =>
  (code.trim().length === 10 || code.trim().length === 12 || code.trim().length === 13 || code.trim().length === 15) &&
  !Number.isNaN(+code.trim());
